import React, { useEffect, useState } from 'react';
import DisposeTableItem from '../../../base/dispose-tab-item';
import { decryptTextByAES } from '../../../../../utils/encryption';

interface IComponentProps {
	data?: any;
}
const CarRelatVeh: React.FC<IComponentProps> = props => {
	const data = props.data;
	const [dataList, setDataList] = useState<any[]>([]);

	useEffect(() => {
		const { relate_veh } = data;
		const list = relate_veh?.map((veh: any) => {
			return {
				text: decryptTextByAES(veh.veh_num),
				tagText: veh.status === 1 ? '已下架' : '',
			};
		});
		setDataList(list);
	}, [data]);

	return (
		<>
			<DisposeTableItem dataList={dataList}></DisposeTableItem>
		</>
	);
};

export default CarRelatVeh;
